export default {"src":"/_next/static/media/headerGroupIcno4.11c8727a.svg","height":166,"width":214,"blurWidth":0,"blurHeight":0};